import { inject, Injectable, Injector } from '@angular/core';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import { contentConnectorToken } from '../../outputs/annotation/utils/misc-utils';
import { ContextMenuOptionsService } from './context-menu-options.service';
import { ContextMenuService } from './context-menu.service';

@Injectable()
export class ShapeContextMenuService {
  private contextMenuOptionsService = inject(ContextMenuOptionsService);
  private injector = inject(Injector);
  private contextMenuService = inject(ContextMenuService);

  async open(clientPoint: Point2D) {
    const menuOptions = await this.getShapeMenuOptions();
    this.contextMenuService.open(menuOptions, clientPoint, true);
  }

  // The content connector is not yet initialized when the context menu service
  // is provided.
  private getContentConnector() {
    return this.injector.get(contentConnectorToken);
  }

  private async getShapeMenuOptions() {
    const menuOptions =
      await this.getContentConnector().getContextMenuOptions('shape');

    menuOptions.push(
      ...(await this.contextMenuOptionsService.getShapeContextMenuOptions()),
    );

    return menuOptions;
  }
}
